import React, { useEffect } from "react";
import "./HomeCard.css";

const HomeCard = () => {
  useEffect(() => {
    const body = document.querySelector("#root");
    if (body) {
      body.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, []);

  const cards = [
    {
      id: 1,
      title: "KIDS",
      video:
        "https://res.cloudinary.com/dk50cmtps/video/upload/v1758259789/Admission_Open_Join_our_vibrant_classes_for_Kids_Adults_Class_Time-_5-30_PM_6-30_PM_F_bq3ffa.mp4",
    },
    {
      id: 2,
      title: "ADULTS",
      video:
        "https://res.cloudinary.com/dk50cmtps/video/upload/v1759296565/Trending_reels_kanimaa_pd_power_of_dreamsz_pd_team_boy_s_trendingreels_music_dancer_d_wzf3js.mp4",
    },
    {
      id: 3,
      title: "ZUMBA",
      video:
        "https://res.cloudinary.com/dk50cmtps/video/upload/v1760098027/Zumba_Dance_Workout_voor_gewichtsverlies_oernoj.mp4",
    },
    {
      id: 4,
      title: "ONLINE",
      video:
        "https://res.cloudinary.com/dk50cmtps/video/upload/v1759842465/Trending_vibe_trendingsongs_trendingreels_dance_music_urnvoj.mp4",
    },
  ];

  return (
    <div className="container pd_cr_container">
      <div className="row">
        {cards.map((card) => (
          <div
            key={card.id}
            className="col-lg-6 col-md-6 col-sm-12 pd_cr_card_wrapper"
          >
            <div className="pd_cr_card shadow-lg border-0 rounded-4 overflow-hidden position-relative">
              <video
                src={card.video}
                className="pd_cr_video"
                autoPlay
                muted
                loop
                playsInline
              />
              <div className="pd_cr_overlay d-flex align-items-center justify-content-center">
                <h5 className="pd_cr_card_title text-light fw-bold text-uppercase">
                  {card.title}
                </h5>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomeCard;
